import { useLazyQuery } from '@apollo/client';
import { QueryResult, Variables } from './types';
import { supplierQuery } from './gql';

export const useSupplierGql = () => {
  const [runSupplierGql, { loading, data, error }] = useLazyQuery<QueryResult, Variables>(supplierQuery, {
    context: {
      headers: {
        userFunctionKey: '9f61408e3afb633e50cdf1b20de6f466'
      }
    },
    fetchPolicy: 'network-only'
  });

  return {
    runSupplierGql,
    loadingSupplier: loading,
    dataSupplier: data?.getSupplier || [],
    errorSupplier: error
  };
};
